export function prettyMetricsName(metricsName: string | null) {
  return metricsName || ''
}
